"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var Yup = _interopRequireWildcard(require("yup"));
var _constants = require("../../utils/constants");
var _recoveryMethod = require("../../hooks/recoveryMethod");
var _formik = require("formik");
var _FormLabel = _interopRequireDefault(require("../FormLabel"));
var _FormErrorMessage = _interopRequireDefault(require("../FormErrorMessage"));
var _CodeInput = _interopRequireDefault(require("../Input/CodeInput"));
var _components = require("./components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DEFAULT_COUNT_DOWN = 60;
var CodeVerifyForm = function CodeVerifyForm(_ref) {
  var _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    method = _ref.method,
    onResend = _ref.onResend,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose;
  var _useState = (0, _react.useState)(DEFAULT_COUNT_DOWN),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    countDown = _useState2[0],
    setCountDown = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var formatted = (0, _recoveryMethod.useFormattedMethod)(method.value, method.type === _constants.recoveryMethods.phone);
  var validate = Yup.object().shape({
    code: Yup.string().length(6).required('Requireed')
  });
  (0, _react.useEffect)(function () {
    if (countDown > 0) {
      setTimeout(function () {
        return setCountDown(function (state) {
          return state - 1;
        });
      }, 1000);
    }
  }, [countDown]);
  var handleOnResend = function handleOnResend() {
    setCountDown(DEFAULT_COUNT_DOWN);
    onResend();
  };
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    validationSchema: validate,
    onSubmit: onSubmit
  }, function (_ref2) {
    var isValid = _ref2.isValid;
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "h-full"
    }, /*#__PURE__*/_react["default"].createElement(_components.Layout, {
      title: t("recoveryMethod.verify.".concat(method.type, ".title")),
      actions: /*#__PURE__*/_react["default"].createElement(_components.ButtonGroup, {
        disabled: !isValid,
        isLoading: isLoading,
        onClose: onClose
      }, t('button.verify'))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-8"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], null, t('forgotPassword.verify.method.label')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold text-dark"
    }, formatted)), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "code"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], null, t('forgotPassword.verify.code.label')), /*#__PURE__*/_react["default"].createElement(_CodeInput["default"], {
      name: "code",
      disabled: isLoading,
      invalid: !isValid,
      className: "block w-full font-bold text-dark"
    }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], null)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
      i18nKey: "recoveryMethod.verify.resend",
      count: countDown > 0 ? 2 : 1,
      values: {
        countDown: countDown
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-primary font-bold"
    }), /*#__PURE__*/_react["default"].createElement("button", {
      className: "text-primary font-bold",
      onClick: handleOnResend
    })))));
  });
};
var _default = exports["default"] = CodeVerifyForm;
//# sourceMappingURL=CodeVerifyForm.js.map